export default __webpack_public_path__ + "002b0a91f28cced3e3fde58a94392f5c.png";